/* tslint:disable */
/* eslint-disable */
/**
 * Melco Rest Services
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    MelcoModelsCustomWarning,
    MelcoModelsCustomWarningFromJSON,
    MelcoModelsCustomWarningFromJSONTyped,
    MelcoModelsCustomWarningToJSON,
} from './';

/**
 * 
 * @export
 * @interface MelcoModelsLogData
 */
export interface MelcoModelsLogData {
    /**
     * 
     * @type {number}
     * @memberof MelcoModelsLogData
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof MelcoModelsLogData
     */
    file_name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MelcoModelsLogData
     */
    device_name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MelcoModelsLogData
     */
    category?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MelcoModelsLogData
     */
    description?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof MelcoModelsLogData
     */
    created_on?: Date;
    /**
     * 
     * @type {string}
     * @memberof MelcoModelsLogData
     */
    product_code?: string | null;
    /**
     * 
     * @type {Array<MelcoModelsCustomWarning>}
     * @memberof MelcoModelsLogData
     */
    warning_list?: Array<MelcoModelsCustomWarning> | null;
}

export function MelcoModelsLogDataFromJSON(json: any): MelcoModelsLogData {
    return MelcoModelsLogDataFromJSONTyped(json, false);
}

export function MelcoModelsLogDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): MelcoModelsLogData {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'file_name': !exists(json, 'file_name') ? undefined : json['file_name'],
        'device_name': !exists(json, 'device_name') ? undefined : json['device_name'],
        'category': !exists(json, 'category') ? undefined : json['category'],
        'description': !exists(json, 'description') ? undefined : json['description'],
        'created_on': !exists(json, 'created_on') ? undefined : (new Date(json['created_on'])),
        'product_code': !exists(json, 'product_code') ? undefined : json['product_code'],
        'warning_list': !exists(json, 'warning_list') ? undefined : (json['warning_list'] === null ? null : (json['warning_list'] as Array<any>).map(MelcoModelsCustomWarningFromJSON)),
    };
}

export function MelcoModelsLogDataToJSON(value?: MelcoModelsLogData | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'file_name': value.file_name,
        'device_name': value.device_name,
        'category': value.category,
        'description': value.description,
        'created_on': value.created_on === undefined ? undefined : (value.created_on.toISOString()),
        'product_code': value.product_code,
        'warning_list': value.warning_list === undefined ? undefined : (value.warning_list === null ? null : (value.warning_list as Array<any>).map(MelcoModelsCustomWarningToJSON)),
    };
}


